'use strict';

import _firebase from './_firebase.js';
import other        from './other.js';
import axios from 'axios';


const address = "https://rosepetal-orchestrator-685118579523.us-central1.run.app" //"https://jupyter.rosepetal.ai/vlm";

const embedd = {
	/**
	 * Sends a predict request to the ds_embedd service.

	 * @param {string} projectId - The project ID for Firebase.
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	predict: async function (projectId, dataset_id, dataset_type, threshold ) {
		const token = _firebase.auth.currentUser.accessToken;
        const numericThreshold = parseFloat(threshold);
        console.log(numericThreshold);
		const accesToken = 'Bearer ' + token;
		try {
			const response = await axios.post(
				`${address}/inference/ds_embedd/`,
				{ dataset_id, dataset_type, threshold: numericThreshold},
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error fetching predictions:", error);
			throw error;
		}
	},
	/**
	 * Sends a predict request to the ds_embedd service.

	 * @param {string} projectId - The project ID for Firebase.
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	cache: async function (projectId, dataset_id, dataset_type ) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			const response = await axios.post(
				`${address}/inference/ds_embedd/`,
				{ dataset_id, dataset_type},
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error caching:", error);
			throw error;
		}
	},
	checkEmbeddhealth: async function (projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			console.log("Checking Embedd health...");
			const response = await axios.get(
				`${address}/service/ds_embedd/`,
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			console.log("Embedd health check response:", response);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
	},
	classificationReviewAction: async function (dataset_id, action){
		if (dataset_id){
			let call = 'api/dataset/' + dataset_id + '/reviewaction';
			if(action){
				call = call + '?action=' + action; //rollback | accept
				console.log("SENDDDED");
				const res = await other.httpsCallable(call);
				console.log("review::::", res);
			}
			else{
				console.log("Define Action")
			}
		}
		else{
			console.log("no dataset_id")
		}
	}
};

export default embedd;
